"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var GoToDb = function (_a) {
    var item = _a.item;
    return ((0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ href: (0, end2end_1.getDocUrl)('stripe_paid_payout_events', item.id), size: "small", color: "neutral" }, { children: "In DB" })));
};
exports.default = GoToDb;
